import { useInitial } from './useInitial'
import { lazy } from 'react'

const ComponentPreviews = lazy(() => import('./previews'))

export { ComponentPreviews, useInitial }
